import React from "react";

const AppPagesLayout = ({ children }) => {
    return <div className="app-pages-layout">{children}</div>;
};

export default AppPagesLayout;
